<template>
  <div>
    <h1 class="page-header">{{ $t('reportPayrollDetail.pageTitle') }}</h1>
    <div class="ts-flex ts--mx-4">
      <div class="ts-w-3/12 ts-px-4">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loadingPreData">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label class="col-form-label control-label required">
                      {{
                      $t('reportPayrollDetail.templateName')
                      }}
                    </label>
                    <div>
                      <ts-select
                        v-model="template_id"
                        :options="reportTemplates.map(t => ({ value: t.template_id, text: t.template_name }))"
                        :class="{ 'is-invalid': errors.has('template_id') }"
                        @change="onSelectedTemplate"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('template_id')"
                      >{{ errors.first('template_id') }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ts-flex ts--mx-2">
                <div class="ts-w-1/2 ts-px-2">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group m-b-10">
                        <label
                          class="col-form-label control-label"
                        >{{ $t('reportPayrollDetail.cycleYear') }}</label>
                        <div>
                          <ts-year-picker-input v-model="cycle_year" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ts-w-1/2 ts-px-2">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group m-b-10">
                        <label
                          class="col-form-label control-label"
                        >{{ $t('reportPayrollDetail.cycleMonth') }}</label>
                        <div>
                          <ts-month-picker-input
                            v-model="cycle_month"
                            format="M"
                            displayFormat="MMM"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <div>
                      <ts-radio
                        v-model.number="id_type"
                        value="1"
                        class="radio-inline"
                        :class="{ 'is-invalid': errors.has('id_type') }"
                      >{{ $t('reportPayrollDetail.orgChartStructure') }}</ts-radio>
                      <ts-radio
                        v-model.number="id_type"
                        value="2"
                        class="radio-inline"
                        :class="{ 'is-invalid': errors.has('id_type') }"
                      >{{ $t('reportPayrollDetail.shift') }}</ts-radio>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="id_type == 1">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label
                      class="col-form-label control-label"
                    >{{ $t('reportPayrollDetail.orgChartStructure') }}</label>
                    <div>
                      <ts-select
                        v-model="org_chart_structure_id"
                        :options="
                        orgChartStructures.map(o => ({ value: o.org_chart_structure_id, text: o.org_chart_structure }))
                      "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="id_type == 2">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label
                      class="col-form-label control-label"
                    >{{ $t('reportPayrollDetail.shiftName') }}</label>
                    <div>
                      <ts-select
                        v-model="shift_id"
                        :options="
                        shifts.map(o => ({ value: o.shift_id, text: o.shift_name + ' (' + o.shift_type + ')'}))
                      "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <label
                      class="col-form-label control-label"
                    >{{ $t('reportPayrollDetail.employee') }}</label>
                    <div>
                      <ts-loading-banner :loading="loadingEmployees">
                        <ts-search-select
                          v-model="employee_id"
                          :options="employeeList"
                          :filterFunction="employeeFilterFunction"
                        />
                      </ts-loading-banner>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-show="template_id">
                <div class="col-sm-12">
                  <div class="form-group m-b-10">
                    <form>
                      <fieldset>
                        <legend>{{ $t('reportPayrollDetail.reportHeader') }}</legend>
                        <div class="row" v-if="report_header.is_caption1">
                          <div class="form-group col-md-12">
                            <label>{{ $t('reportPayrollDetail.captionOne') }}</label>
                            <input
                              v-model="report_header.caption1"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="row" v-if="report_header.is_caption2">
                          <div class="form-group col-md-12">
                            <label>{{ $t('reportPayrollDetail.captionTwo') }}</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="report_header.caption2"
                            />
                          </div>
                        </div>
                        <div class="row" v-if="report_header.is_caption3">
                          <div class="form-group col-md-12">
                            <label>{{ $t('reportPayrollDetail.captionThree') }}</label>
                            <input
                              type="text"
                              v-model="report_header.caption3"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row ts-mt-4">
                <div class="col-sm-12 col-lg-12 col-md-12 ts-text-right">
                  <ts-button
                    outline
                    color="primary"
                    class="mr-2"
                    @click="exportExcel"
                    :waiting="exporting"
                    :disabled="template_id === null || template_id === ''"
                  >Export</ts-button>
                  <ts-button
                    color="primary"
                    @click="viewReport"
                    :waiting="viewing"
                    :disabled="template_id === null || template_id === ''"
                  >View</ts-button>
                </div>
              </div>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="ts-w-9/12 ts-px-4">
        <ts-card>
          <div class="overflow-auto">
            <ts-table
              :columns="resources.length > 0 ? ['No', ...Object.values(columns)] : ['Report viewer']"
              :records="resources"
              :loading="loading"
            >
              <template v-slot="{ record, index }">
                <td
                  class="ts-w-1"
                >{{ (pagination.currentPage - 1) * pagination.perPage + index + 1 }}</td>
                <td
                  class="ts-whitespace-no-wrap"
                  v-for="colName in columns"
                  :key="colName"
                >{{ record[colName] }}</td>
              </template>
              <template v-slot:tfooter v-if="resources.length > 0">
                <th class="ts-bg-gray-100"></th>
                <th
                  v-for="colName in columns"
                  :key="colName"
                  class="ts-bg-gray-100"
                >{{ showEachAggregate(colName) }}</th>
              </template>
            </ts-table>
          </div>
          <div class="d-flex justify-content-end p-15" v-if="resources.length > 0">
            <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
          </div>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { trim, find } from 'lodash'
import { mapState, mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'report-payroll-detail',
  data() {
    return {
      cycle_year: moment().year(),
      cycle_month: moment().month() + 1,
      template_id: '',
      report_header: {
        caption1: '',
        caption1_cell: '',
        caption2: '',
        caption2_cell: '',
        caption3: '',
        caption3_cell: '',
        is_caption1: '',
        is_caption2: '',
        is_caption3: ''
      },
      id_type: 1,
      org_chart_structure_id: '',
      shift_id: '',
      employee_id: '',
      loading: false,
      loadingEmployees: false,
      exporting: false,
      viewing: false,
      loadingPreData: false,
      errors: new Errors()
    }
  },
  created() {
    this.loadingPreData = true
    Promise.all([this.fetchTemplates(), this.fetchOrgStructures(), this.fetchShift()]).then(() => {
      this.loadingPreData = false
    })
  },
  computed: {
    ...mapState('hr/reportPayrollDetail', [
      'resources',
      'pagination',
      'aggregate',
      'columns',
      'reportTemplates',
      'orgChartStructures',
      'shifts',
      'employees'
    ]),
    search: {
      get() {
        return this.$store.state.hr.reportPayrollDetail.search
      },
      set(newValue) {
        this.$store.commit('hr/reportPayrollDetail/SET_SEARCH', newValue)
        this.$store.commit('hr/reportPayrollDetail/RESET_CURRENT_PAGE')
      }
    },
    showEachAggregate: vm => colName => {
      const aggregate = find(vm.aggregate, (a, k) => k === colName)

      if (aggregate === undefined) return ''

      return aggregate.value
    },
    employeeList() {
      let emp = this.employees.map(em => ({ value: em.employee_id, text: em.employee_name_en }))
      emp.push({ value: '', text: 'All' })
      return emp.sort(function(first, second) {
        if (first.text < second.text) {
          return -1
        }
        if (first.text > second.text) {
          return 1
        }
        return 0
      })
    }
  },
  methods: {
    ...mapActions('hr/reportPayrollDetail', ['fetchTemplates', 'fetchOrgStructures', 'fetchShift']),

    fetch(attributes) {
      return this.$store.dispatch('hr/reportPayrollDetail/fetch', {
        ...attributes,
        template_id: this.template_id,
        cycle_year: this.cycle_year,
        cycle_month: this.cycle_month,
        org_chart_structure_id: this.org_chart_structure_id,
        id_type: this.id_type,
        shift_id: this.shift_id,
        employee_id: this.employee_id ? this.employee_id : this.employees.map(em => em.employee_id)
      })
    },

    viewReport(attributes) {
      this.viewing = true
      this.fetch(attributes)
        .then(() => {
          this.viewing = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },

    fetchData(attributes) {
      this.loading = true
      this.fetch(attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },

    exportExcel() {
      this.exporting = true

      this.$store
        .dispatch('hr/reportPayrollDetail/exportExcel', {
          template_id: this.template_id,
          cycle_year: this.cycle_year,
          cycle_month: this.cycle_month,
          employee_id: this.employee_id ? this.employee_id : this.employees.map(em => em.employee_id),
          id_type: this.id_type,
          shift_id: this.shift_id,
          report_header: this.report_header
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(response.headers['content-disposition'].indexOf('filename'))
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err)))
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    },

    employeeFilterFunction(search, options) {
      return options.filter(option => {
        return option.text.toLowerCase().includes(search.toLowerCase())
      })
    },
    onSelectedTemplate() {
      if (!this.template_id) {
        this.report_header = {}
        return
      }
      this.reportTemplates
        .filter(t => t.template_id == this.template_id)
        .map(el => {
          this.report_header = {
            caption1: el.caption1,
            caption1_cell: el.caption1_cell,
            caption2: el.caption2,
            caption2_cell: el.caption2_cell,
            caption3: el.caption3,
            caption3_cell: el.caption3_cell,
            is_caption1: el.is_caption1,
            is_caption2: el.is_caption2,
            is_caption3: el.is_caption3
          }
        })
    }
  },
  watch: {
    org_chart_structure_id: {
      handler(orgChartStructureId) {
        this.loadingEmployees = true

        this.$store
          .dispatch('hr/reportPayrollDetail/getByPositionHierarchies', orgChartStructureId)
          .finally(() => (this.loadingEmployees = false))
      }
    },
    shift_id: {
      handler(shiftId) {
        this.loadingEmployees = true

        this.$store
          .dispatch('hr/reportPayrollDetail/getEmployeeByShift', shiftId)
          .finally(() => (this.loadingEmployees = false))
      }
    },
    id_type: function(value) {
      if (value == 1) {
        this.shift_id = ''
      } else {
        this.org_chart_structure_id = ''
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/reportPayrollDetail/RESET_STATE')
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
/* customize fieldset style */
fieldset {
  border: 1px solid #c3c3c3;
  padding: 10px 15px !important;
  border-radius: 4px;
}

fieldset legend {
  border: 1px solid #ffff;
  width: auto;
  padding: 5px 14px;
  // border-radius: 7px;
  font-size: 14px;
  // box-shadow: -1px 4px 27px -7px #bdbdbd;
  background: #fffdfd;
}
</style>
